import { IconoChevronAbajo } from '../iconos';
import './listado.css';

export interface OpcionFiltro {
  valor: string;
  etiqueta: string;
}

/**
 * Un filtro de la barra: la caja «Tipo: Todos ⌄» del Figma.
 *
 * Por debajo es un `<select>` nativo, transparente y del tamaño de la caja. Lo
 * que se ve es el texto armado; lo que se toca es el control del navegador. Así
 * en el celular sale el selector del sistema y el teclado y el lector de
 * pantalla funcionan sin escribir nada a mano.
 */
export function Filtro({
  etiqueta,
  opciones,
  valor,
  onCambiar,
  deshabilitado = false,
}: {
  /** «Tipo», «Categoría», «Estado». Los dos puntos los pone el componente. */
  etiqueta: string;
  opciones: readonly OpcionFiltro[];
  valor: string;
  onCambiar: (valor: string) => void;
  /** Un filtro que en ese momento no se aplica —en el listado, el estado mientras se busca (#165)—. */
  deshabilitado?: boolean;
}) {
  const actual = opciones.find((o) => o.valor === valor) ?? opciones[0];

  return (
    <div className={deshabilitado ? 'ui-filtro ui-filtro--deshabilitado' : 'ui-filtro'}>
      <span aria-hidden="true">
        {etiqueta}: {actual?.etiqueta}
      </span>
      <IconoChevronAbajo />
      <select
        aria-label={etiqueta}
        value={valor}
        disabled={deshabilitado}
        onChange={(e) => onCambiar(e.target.value)}
      >
        {opciones.map((o) => (
          <option key={o.valor} value={o.valor}>
            {o.etiqueta}
          </option>
        ))}
      </select>
    </div>
  );
}
